import { render, staticRenderFns } from "./pbbtransfer.vue?vue&type=template&id=572e10bc&"
import script from "./pbbtransfer.vue?vue&type=script&lang=js&"
export * from "./pbbtransfer.vue?vue&type=script&lang=js&"
import style0 from "./pbbtransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports